import React from 'react';
import { BrowserRouter } from 'react-router-dom'; // ✅ Import BrowserRouter
import CompanyPage from './pages/index';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <CompanyPage />
      </div>
    </BrowserRouter>
  );
};

export default App;
